export default __webpack_public_path__ + "static/media/pcdashboard.37f35ed0.png";